import { render } from "./App.vue?vue&type=template&id=22202dd4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=22202dd4&lang=scss"

import exportComponent from "/Users/mum/Documents/mym/book-stack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__